import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card bg-white border-0 rounded-3 mb-4" }
const _hoisted_2 = { class: "card-body p-4" }
const _hoisted_3 = { class: "ps-0 mb-4 list-unstyled sidebar" }
const _hoisted_4 = { class: "mb-3 pb-1 d-flex justify-content-between align-items-center" }
const _hoisted_5 = { class: "mb-3 pb-1" }
const _hoisted_6 = { class: "mb-3 pb-1" }
const _hoisted_7 = { class: "mb-3 pb-1" }
const _hoisted_8 = { class: "mb-3 pb-1" }
const _hoisted_9 = { class: "mb-3 pb-1" }
const _hoisted_10 = { class: "mb-3 pb-1" }
const _hoisted_11 = { class: "mb-3 pb-1" }
const _hoisted_12 = { class: "mb-3 pb-1" }
const _hoisted_13 = { class: "mb-3 pb-1" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[14] || (_cache[14] = _createElementVNode("form", { class: "position-relative default-src-form mb-3 pb-1" }, [
        _createElementVNode("input", {
          type: "text",
          class: "form-control rounded-1",
          placeholder: "Search"
        }),
        _createElementVNode("i", { class: "material-symbols-outlined position-absolute top-50 start-0 translate-middle-y fs-18" }, " search ")
      ], -1)),
      _createVNode(_component_RouterLink, {
        to: "/apps/email/compose",
        class: "btn btn-primary fs-16 fw-medium text-center d-block py-2 mb-4"
      }, {
        default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
          _createElementVNode("div", { class: "d-flex align-items-center justify-content-center py-lg-1" }, [
            _createElementVNode("i", { class: "material-symbols-outlined fs-18 me-2" }, "edit"),
            _createElementVNode("span", null, "Compose")
          ], -1)
        ]))]),
        _: 1
      }),
      _createElementVNode("ul", _hoisted_3, [
        _createElementVNode("li", _hoisted_4, [
          _createVNode(_component_RouterLink, {
            to: "/apps/email/inbox",
            class: "d-flex align-items-center text-decoration-none"
          }, {
            default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
              _createElementVNode("i", { class: "material-symbols-outlined fs-18 position-relative top-1 me-2" }, " inbox ", -1),
              _createElementVNode("span", { class: "fw-semibold" }, "Inbox", -1)
            ]))]),
            _: 1
          }),
          _cache[2] || (_cache[2] = _createElementVNode("span", { class: "fs-13" }, "10", -1))
        ]),
        _createElementVNode("li", _hoisted_5, [
          _createVNode(_component_RouterLink, {
            to: "/apps/email/starred",
            class: "d-flex align-items-center text-decoration-none"
          }, {
            default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
              _createElementVNode("i", { class: "material-symbols-outlined fs-18 position-relative top-1 me-2" }, " star_rate ", -1),
              _createElementVNode("span", { class: "fw-medium" }, "Started", -1)
            ]))]),
            _: 1
          })
        ]),
        _createElementVNode("li", _hoisted_6, [
          _createVNode(_component_RouterLink, {
            to: "/apps/email/snoozed",
            class: "d-flex align-items-center text-decoration-none"
          }, {
            default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
              _createElementVNode("i", { class: "material-symbols-outlined fs-18 position-relative top-1 me-2" }, " alarm ", -1),
              _createElementVNode("span", { class: "fw-medium" }, "Snoozed", -1)
            ]))]),
            _: 1
          })
        ]),
        _createElementVNode("li", _hoisted_7, [
          _createVNode(_component_RouterLink, {
            to: "/apps/email/sent-mail",
            class: "d-flex align-items-center text-decoration-none"
          }, {
            default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
              _createElementVNode("i", { class: "material-symbols-outlined fs-18 position-relative top-1 me-2" }, " send ", -1),
              _createElementVNode("span", { class: "fw-medium" }, "Sent", -1)
            ]))]),
            _: 1
          })
        ]),
        _createElementVNode("li", _hoisted_8, [
          _createVNode(_component_RouterLink, {
            to: "/apps/email/draft",
            class: "d-flex align-items-center text-decoration-none"
          }, {
            default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
              _createElementVNode("i", { class: "material-symbols-outlined fs-18 position-relative top-1 me-2" }, " draft ", -1),
              _createElementVNode("span", { class: "fw-medium" }, "Drafts", -1)
            ]))]),
            _: 1
          })
        ]),
        _createElementVNode("li", _hoisted_9, [
          _createVNode(_component_RouterLink, {
            to: "/apps/email/important",
            class: "d-flex align-items-center text-decoration-none"
          }, {
            default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
              _createElementVNode("i", { class: "material-symbols-outlined fs-18 position-relative top-1 me-2" }, " bookmark ", -1),
              _createElementVNode("span", { class: "fw-medium" }, "Important", -1)
            ]))]),
            _: 1
          })
        ]),
        _createElementVNode("li", _hoisted_10, [
          _createVNode(_component_RouterLink, {
            to: "/apps/chat",
            class: "d-flex align-items-center text-decoration-none"
          }, {
            default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
              _createElementVNode("i", { class: "material-symbols-outlined fs-18 position-relative top-1 me-2" }, " auto_read_pause ", -1),
              _createElementVNode("span", { class: "fw-medium" }, "Chats", -1)
            ]))]),
            _: 1
          })
        ]),
        _cache[12] || (_cache[12] = _createElementVNode("li", { class: "mb-3 pb-1" }, [
          _createElementVNode("a", {
            href: "javascript:void(0);",
            class: "d-flex align-items-center text-decoration-none"
          }, [
            _createElementVNode("i", { class: "material-symbols-outlined fs-18 position-relative top-1 me-2" }, " schedule_send "),
            _createElementVNode("span", { class: "fw-medium" }, "Scheduled")
          ])
        ], -1)),
        _createElementVNode("li", _hoisted_11, [
          _createVNode(_component_RouterLink, {
            to: "/apps/email/inbox",
            class: "d-flex align-items-center text-decoration-none"
          }, {
            default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
              _createElementVNode("i", { class: "material-symbols-outlined fs-18 position-relative top-1 me-2" }, " forward_to_inbox ", -1),
              _createElementVNode("span", { class: "fw-medium" }, "All Mail", -1)
            ]))]),
            _: 1
          })
        ]),
        _createElementVNode("li", _hoisted_12, [
          _createVNode(_component_RouterLink, {
            to: "/apps/email/spam",
            class: "d-flex align-items-center text-decoration-none"
          }, {
            default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
              _createElementVNode("i", { class: "material-symbols-outlined fs-18 position-relative top-1 me-2" }, " live_help ", -1),
              _createElementVNode("span", { class: "fw-medium" }, "Spam", -1)
            ]))]),
            _: 1
          })
        ]),
        _createElementVNode("li", _hoisted_13, [
          _createVNode(_component_RouterLink, {
            to: "/apps/email/trash-email",
            class: "d-flex align-items-center text-decoration-none"
          }, {
            default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
              _createElementVNode("i", { class: "material-symbols-outlined fs-18 position-relative top-1 me-2" }, " delete ", -1),
              _createElementVNode("span", { class: "fw-medium" }, "Trash", -1)
            ]))]),
            _: 1
          })
        ]),
        _cache[13] || (_cache[13] = _createStaticVNode("<li class=\"mb-3 pb-1\" data-v-9d47f288><a href=\"javascript:void(0);\" class=\"d-flex align-items-center text-decoration-none\" data-v-9d47f288><i class=\"material-symbols-outlined fs-18 position-relative top-1 me-2\" data-v-9d47f288> account_circle </i><span class=\"fw-medium\" data-v-9d47f288>Personal</span></a></li><li class=\"mb-0\" data-v-9d47f288><a href=\"javascript:void(0);\" class=\"d-flex align-items-center text-decoration-none\" data-v-9d47f288><i class=\"material-symbols-outlined fs-18 position-relative top-1 me-2\" data-v-9d47f288> trip </i><span class=\"fw-medium\" data-v-9d47f288>Company</span></a></li>", 2))
      ]),
      _cache[15] || (_cache[15] = _createElementVNode("button", {
        class: "btn btn-outline-primary py-1 px-2 px-sm-4 fs-14 fw-medium rounded-3 hover-bg",
        "data-bs-toggle": "offcanvas",
        "data-bs-target": "#addNewLabelModal",
        "aria-controls": "addNewLabelModal"
      }, [
        _createElementVNode("span", { class: "py-sm-1 d-block" }, [
          _createElementVNode("i", { class: "ri-add-line d-none d-sm-inline-block me-1" }),
          _createElementVNode("span", null, "Add New Label")
        ])
      ], -1))
    ])
  ]))
}